{
	"nav": {
		"home": "Главная",
		"catalog": "Каталог курсов",
		"library": "Библиотека",
		"materials": "Материалы",
		"favorites": "Избранное",
		"collections": "Папки",
		"notes": "Конспекты",
		"tests": "Тесты",
		"flashcards": "Карточки",
		"glossary": "Глоссарий",
		"tutor": "Чат",
		"recording": "Запись лекции",
		"audioSummary": "Аудио-резюме",
		"essays": "Оценка эссе",
		"visual": "Объяснить по фото",
		"voiceTutor": "Голосовой репетитор",
		"plan": "Учебный план",
		"calendar": "Календарь",
		"progress": "Прогресс",
		"weakSpots": "Слабые места",
		"trash": "Корзина",
		"about": "О сервисе",
		"pricing": "Тарифы",
		"help": "Помощь",
		"features": "Возможности",
		"method": "Метод",
		"course": "Курс",
		"howItWorks": "Как работает",
		"faq": "FAQ",
		"section": {
			"tools": "Инструменты"
		},
		"more": "Ещё",
		"planShort": "План",
		"characters": "Персонажи",
		"folders": "Папки",
		"courses": "Курсы"
	},
	"topbar": {
		"search": "Поиск",
		"commandPalette": "Команды (⌘K)",
		"notifications": "Уведомления",
		"profile": "Профиль",
		"settings": "Настройки",
		"billing": "Подписка",
		"help": "Помощь",
		"signOut": "Выйти",
		"searchOpen": "Открыть поиск",
		"searchPlaceholder": "Поиск по материалам, заметкам, карточкам…",
		"openMenu": "Открыть меню",
		"uploadMaterial": "Загрузить материал",
		"home": "На главную",
		"tutorOpen": "AI-репетитор",
		"tutorLabel": "Репетитор",
		"themeLight": "Светлая тема",
		"themeDark": "Тёмная тема",
		"notificationsUnread": "Уведомления ({count} непрочитанных)",
		"notificationsAll": "Уведомления",
		"login": "Войти",
		"trial": "Попробовать",
		"howItWorks": "Как это работает",
		"guestNav": "Разделы сайта",
		"create": "Создать"
	},
	"addMenu": {
		"title": "Создать",
		"subtitle": "Начните курс или принесите учебный материал.",
		"course": {
			"title": "Курс",
			"desc": "Программа по теме, готовый курс из каталога или пространство для своих материалов"
		},
		"upload": {
			"title": "Загрузить материал",
			"desc": "PDF, документ, видео, ссылка или текст"
		},
		"record": {
			"title": "Записать лекцию",
			"desc": "Лекция станет конспектом"
		},
		"discover": {
			"title": "Найти в интернете",
			"desc": "Поиск в сети (быстрый или глубокий) и сохранение источников в папку библиотеки",
			"hint": "Введите тему — Fast находит источники, Deep составляет отчет. Ничего не сохраняется до вашего подтверждения.",
			"saveFolder": "Сохранить {count, plural, one {# источник} few {# источника} many {# источников} other {# источника}} в папку",
			"savedFolder": "Сохранено {count} источников в папку библиотеки",
			"doneHint": "Откройте в библиотеке или прикрепите всю папку к курсу.",
			"openFolder": "Открыть в библиотеке",
			"attachedToCourse": "Папка добавлена в курс",
			"doneTitle": "Папка готова",
			"attachHeading": "Прикрепить папку к курсу",
			"attachFailed": "Не удалось добавить папку в курс"
		}
	},
	"sidebar": {
		"ariaLabel": "Главная навигация",
		"brand": "StudyHub — на главную",
		"uploadMaterial": "Загрузить материал",
		"studySets": "Папки",
		"allSets": "Все папки",
		"collapse": "Свернуть",
		"expand": "Раскрыть боковую панель",
		"collapseAria": "Свернуть боковую панель",
		"navAriaLabel": "Разделы приложения",
		"createSet": {
			"title": "Создать папку",
			"subtitle": "Группируй материалы по предмету или курсу.",
			"nameLabel": "Название",
			"placeholder": "Например, Анатомия 1 курс",
			"descriptionLabel": "Описание (необязательно)",
			"descriptionPlaceholder": "Краткое описание",
			"colorLabel": "Цвет",
			"materialsLabel": "Материалы (необязательно)",
			"materialsPlaceholder": "Выбрать материалы",
			"materialsSelected": "{count, plural, one {# материал выбран} few {# материала выбрано} many {# материалов выбрано} other {# материалов выбрано}}",
			"materialsSearchPlaceholder": "Поиск по названию…",
			"materialsEmpty": "Нет материалов",
			"materialsNoMatches": "Ничего не найдено",
			"materialsLimitReached": "Достигнут лимит: {limit} материалов",
			"cancel": "Отмена",
			"cta": "Создать",
			"success": "Папка создана",
			"error": "Не удалось создать папку"
		},
		"create": "Создать"
	},
	"tier": {
		"free": "Free",
		"plus": "Plus",
		"pro": "Pro",
		"planLabel": "{tier} план"
	},
	"streak": {
		"days": "{count, plural, one {# день подряд} few {# дня подряд} many {# дней подряд} other {# дня подряд}}",
		"encouragement": "Не теряй ритм",
		"openAria": "Открыть детали серии"
	},
	"promo": {
		"plusTitle": "Открой Plus",
		"plusBody": "Безлимит на AI-генерации и запись лекций без ограничений",
		"plusCta": "Узнать больше"
	},
	"bottomNav": {
		"home": "Дом",
		"materials": "Материалы",
		"study": "Учёба",
		"tutor": "Чат",
		"profile": "Профиль"
	},
	"theme": {
		"label": "Тема",
		"light": "Светлая",
		"dark": "Тёмная",
		"system": "Системная",
		"useSystem": "По системе"
	},
	"language": {
		"label": "Язык",
		"placeholder": "Выберите язык"
	},
	"userMenu": {
		"viewProfile": "Открыть профиль",
		"accountSettings": "Настройки аккаунта",
		"subscription": "Подписка",
		"feedback": "Обратная связь"
	},
	"breadcrumbs": {
		"home": "Главная"
	},
	"mobileDrawer": {
		"title": "Меню навигации",
		"description": "Полный список разделов StudyHub",
		"navAriaLabel": "Расширенная навигация",
		"profile": "Профиль"
	},
	"a11y": {
		"skipToContent": "Перейти к содержимому"
	},
	"panel": {
		"tutorTitle": "Репетитор",
		"notificationsTitle": "Уведомления",
		"close": "Закрыть панель",
		"tutorAria": "Панель репетитора",
		"notificationsAria": "Панель уведомлений",
		"tutorPlaceholder": "Здесь появится чат с репетитором.",
		"notificationsPlaceholder": "Здесь появится лента уведомлений."
	},
	"tooltips": {
		"tutor": "Открыть AI-репетитора",
		"theme": "Сменить тему",
		"notifications": "Уведомления",
		"profile": "Профиль и настройки",
		"search": "Поиск (⌘K)",
		"collapseSidebar": "Свернуть боковую панель",
		"expandSidebar": "Развернуть боковую панель"
	},
	"dailyLoad": {
		"eyebrow": "Сегодня",
		"value": "{done} / {goal} мин",
		"valueCompact": "{done}",
		"aria": "Сегодня: {done} из {goal} минут. Открыть прогресс"
	},
	"moduleState": {
		"product_disabled": {
			"title": "Раздел «{module}» отключён",
			"description": "Ваши материалы на месте — их можно открывать и читать. Создание нового в этом разделе сейчас закрыто."
		},
		"killed": {
			"title": "«{module}» временно недоступен",
			"description": "Мы уже занимаемся этим. Данные не пострадали, создание нового ненадолго закрыто."
		},
		"tier_locked": {
			"title": "«{module}» — на платном тарифе",
			"cta": "Посмотреть тарифы",
			"description": "Раздел «{module}» открывается на платном тарифе."
		},
		"platform_unsupported": {
			"title": "«{module}» недоступен на этом устройстве",
			"description": "Уже созданное можно открыть, а работать с разделом получится в браузере."
		},
		"dependency_missing": {
			"title": "«{module}» зависит от отключённого раздела",
			"description": "Разделу нужен другой раздел, который сейчас отключён. Созданное остаётся доступным для чтения."
		},
		"external_down": {
			"title": "Внешний сервис «{module}» не отвечает",
			"description": "Показываем сохранённые данные. Попробуйте повторить чуть позже."
		},
		"lifecycle_removed": {
			"title": "«{module}» выведен из эксплуатации",
			"description": "Созданное остаётся доступным для чтения, новое в этом разделе больше не создаётся."
		}
	},
	"pullToRefresh": {
		"refreshing": "Обновляем…"
	}
}
